import { render } from "./ClaimPreviewModal.vue?vue&type=template&id=1b49c19d&scoped=true"
import script from "./ClaimPreviewModal.vue?vue&type=script&lang=js"
export * from "./ClaimPreviewModal.vue?vue&type=script&lang=js"

import "./ClaimPreviewModal.vue?vue&type=style&index=0&id=1b49c19d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b49c19d"]])

export default __exports__